import * as actionTypes from './actionTypes';

// RESET
export const resetState = () => {
    return {
        type: actionTypes.RESET_STATE
    }
}